import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { lovable } from "@/integrations/lovable/index";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/auth")({
  ssr: false,
  head: () => ({
    meta: [
      { title: "Aanmelden | IT Solutions" },
      { name: "description", content: "Aanmelden voor het beheer van IT Solutions." },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Aanmelden | IT Solutions" },
      { property: "og:description", content: "Aanmelden voor het beheer van IT Solutions." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: AuthPage,
});

function AuthPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    void supabase.auth.getSession().then(({ data }) => {
      if (data.session) void navigate({ to: "/admin/leads", replace: true });
    });
  }, [navigate]);

  async function signIn() {
    setBusy(true);
    setError(null);
    const result = await lovable.auth.signInWithOAuth("google", {
      // Terug naar /auth (niet de homepage): de sessie-check hierboven
      // stuurt een aangemelde beheerder meteen door naar /admin/leads.
      redirect_uri: `${window.location.origin}/auth`,
    });
    if (result.error) {
      setError("Aanmelden is niet gelukt. Probeer het opnieuw.");
      setBusy(false);
      return;
    }
    if (result.redirected) return;
    void navigate({ to: "/admin/leads", replace: true });
  }

  return (
    <main className="mx-auto flex min-h-[60vh] max-w-md flex-col justify-center px-6 py-24">
      <h1 className="text-3xl font-semibold tracking-tight">Beheer</h1>
      <p className="mt-3 text-muted-foreground">
        Meld je aan met je Google-account om de contactaanvragen te bekijken.
      </p>
      <Button className="mt-8" onClick={signIn} disabled={busy}>
        {busy ? "Bezig…" : "Aanmelden met Google"}
      </Button>
      {error ? <p className="mt-4 text-sm text-destructive">{error}</p> : null}
    </main>
  );
}
